import { useMemo } from 'react';

import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

import { ReactComponent as VRLineIcon } from '../../../../assets/icons/condashvr-line.svg';

import { ReactComponent as DatabaseConnectedIcon } from '../../../../assets/icons/database-check-icon.svg';
import { ReactComponent as DatabaseDisconnectedIcon } from '../../../../assets/icons/database-remove-icon.svg';
import { ReactComponent as ConnectedIcon } from '../../../../assets/connectivitydashboard/emqx-connected-icon.svg';
import { ReactComponent as DisconnectedIcon } from '../../../../assets/connectivitydashboard/emqx-disconnected-icon.svg';
import { ReactComponent as PLCConnectedIcon } from '../../../../assets/connectivitydashboard/plc-connected-icon.svg';
import { ReactComponent as PLCDisconnectedIcon } from '../../../../assets/connectivitydashboard/plc-disconnected-icon.svg';

const getMQTTStatus = (status: string, color?: any) => {
  switch (status) {
    case 'connected':
      return {
        title: 'Connected',
        icon: ConnectedIcon,
        color: color.success.main,
      };
    case 'disconnected':
      return {
        title: 'Disconnected',
        icon: DisconnectedIcon,
        color: color.error.main,
      };
    case 'warning':
      return {
        title: 'Warning',
        icon: DisconnectedIcon,
        color: color.warning.main,
      };
    default:
      return {
        title: 'Waiting',
        icon: DisconnectedIcon,
        color: color.error.main,
      };
  }
};

const getDBStatus = (status: string, color?: any) => {
  switch (status) {
    case 'connected':
      return {
        title: 'Connected',
        icon: DatabaseConnectedIcon,
        color: color.success.main,
      };
    case 'disconnected':
      return {
        title: 'Disconnected',
        icon: DatabaseDisconnectedIcon,
        color: color.error.main,
      };
    case 'warning':
      return {
        title: 'Warning',
        icon: DatabaseDisconnectedIcon,
        color: color.warning.main,
      };
    default:
      return {
        title: 'Waiting',
        icon: DatabaseDisconnectedIcon,
        color: color.error.main,
      };
  }
};

const getPLCStatus = (status: string, color?: any) => {
  switch (status) {
    case 'connected':
      return {
        title: 'Connected',
        icon: PLCConnectedIcon,
        color: color.success.main,
      };
    case 'disconnected':
      return {
        title: 'Disconnected',
        icon: PLCDisconnectedIcon,
        color: color.error.main,
      };
    case 'warning':
      return {
        title: 'Warning',
        icon: PLCDisconnectedIcon,
        color: color.warning.main,
      };
    default:
      return {
        title: 'Waiting',
        icon: PLCDisconnectedIcon,
        color: color.error.main,
      };
  }
};

interface NodeStatusesProps {
  statuses: {
    mqttStatus: any;
    plcStatus: any;
    dbStatus: any;
  };
  palette: any;
}

const NodeStatuses = ({ statuses, palette }: NodeStatusesProps) => {
  const { mqttStatus, plcStatus, dbStatus } = useMemo(() => {
    return {
      mqttStatus: getMQTTStatus(statuses.mqttStatus, palette),
      plcStatus: getPLCStatus(statuses.plcStatus, palette),
      dbStatus: getDBStatus(statuses.dbStatus, palette),
    };
  }, [statuses, palette]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        mr: '12px',
      }}
    >
      <VRLineIcon />
      <Tooltip title={mqttStatus.title} arrow placement='top'>
        <mqttStatus.icon style={{ color: mqttStatus.color }} />
      </Tooltip>
      <Tooltip title={plcStatus.title} arrow placement='top'>
        <plcStatus.icon style={{ color: plcStatus.color }} />
      </Tooltip>
      <Tooltip title={dbStatus.title} arrow placement='top'>
        <dbStatus.icon style={{ color: dbStatus.color }} />
      </Tooltip>
    </Box>
  );
};

export default NodeStatuses;
